const LATIN_ALPHABET = 'a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF\\u0100-\\u024F';
const GREEK_ALPHABET = '\\u0370-\\u03FF';
const CYRILLIC_ALPHABET = '\\u0400-\\u04FF';
const HEBREW_ALPHABET = '\\u0590-\\u05FF';
const ARABIC_ALPHABET = '\\u0600-\\u06FF';
const ALL_CHARACTERS = [LATIN_ALPHABET, GREEK_ALPHABET, CYRILLIC_ALPHABET, HEBREW_ALPHABET, ARABIC_ALPHABET].join('');

export default ALL_CHARACTERS;
